<template>
  <base-resize-observer
    @resize="onResize"
  >
    <div
      :data-id="itemId"
      :data-index="realIndex"
      class="base-virtual-scroll-viewport-item"
    >
      <keep-alive>
        <slot
          v-if="isActivated"
          name="default"
        />
        <div
          v-else
          :style="{ height: `${itemSize}px` }"
        >
          <slot name="placeholder" />
        </div>
      </keep-alive>
    </div>
  </base-resize-observer>
</template>

<script lang="ts">
import {
  defineComponent,
  onActivated,
  onDeactivated,
  onBeforeUnmount,
  ref,
} from 'vue-demi';

import { IResizeInfo } from '../../../types';
import { BaseResizeObserver } from '../../decorators';
import { DEFAULT_RENDER_DELAY } from '../../../constants';

export default defineComponent({
  name: 'BaseVirtualScrollViewportItem',
  components: {
    BaseResizeObserver,
  },
  props: {
    itemId: {
      type: [String, Number],
      required: true,
    },
    realIndex: {
      type: Number,
      required: true,
    },
    itemSize: {
      type: Number,
      required: true,
    },
    renderDelay: {
      type: Number,
      default: DEFAULT_RENDER_DELAY,
    },
  },
  emits: ['activation', 'deactivation', 'resize'],
  setup(props, ctx) {
    const isActivated = ref(false);
    let timer: number;

    const cancel = () => {
      clearInterval(timer);
    };

    onActivated(() => {
      timer = window.setTimeout(async () => {
        isActivated.value = true;
        ctx.emit('activation');
      }, props.renderDelay);
    });

    onDeactivated(() => {
      isActivated.value = false;
      cancel();
      ctx.emit('deactivation');
    });

    onBeforeUnmount(() => {
      cancel();
    });

    const onResize = (event: IResizeInfo) => {
      if (event.height) {
        ctx.emit('resize', event);
      }
    };

    return { onResize, isActivated };
  },
});
</script>
